module.exports = __webpack_public_path__ + "img/Flag_of_Ghana.e3e2341e.svg";